import dayjs from "dayjs";
import { i18n, useTranslation } from "@coworker/locales";
import {
  calcDaysOverdue,
  calcOverdueString,
} from "@coworker/apprestructured/src/task-management/util";
import Overdue from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Start/Overdue/Overdue";
import ScheduledFor from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Start/ScheduledFor/ScheduledFor";
import { getDateFormatsForLocale } from "@coworker/apprestructured/src/shared/components/DatePicker/helper";

type StartProps = {
  date: string; // e.g. 2026-01-23
};

function Start({ date }: StartProps) {
  const { t } = useTranslation();

  const daysOverdue = calcDaysOverdue(date);
  if (daysOverdue > 0) {
    return <Overdue text={calcOverdueString(daysOverdue, t)} />;
  } else if (daysOverdue === 0) {
    return <ScheduledFor text={t("scheduledForTodayString")} />;
  } else if (daysOverdue === -1) {
    return <ScheduledFor text={t("scheduledForTomorrowString")} />;
  } else {
    return (
      <ScheduledFor
        text={`${t("scheduledForString")} ${dayjs(date).format(getDateFormatsForLocale(i18n.language).full)}`}
      />
    );
  }
}

export default Start;
